import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { uniqueId } from 'lodash';

import connectEditElementToBriefStore from 'contest/components/connected/connect-edit-element-to-brief-store';
import { connectReadElement } from 'contest/components/brief/read-element';

export const ViewMultipleChoiceOtherElement = ({ choices }) => (
    <ul>{choices.map((choice, i) => <li key={i}>{choice}</li>)}</ul>
);
ViewMultipleChoiceOtherElement.propTypes = {
    choices: PropTypes.array.isRequired,
};

export const ConnectedViewMultipleChoiceOtherElement = connectReadElement(
    ViewMultipleChoiceOtherElement,
    element => {
        const choices = element.value.choices.map(choice => {
            return element.trans.choices[choice];
        });
        if (element.value.other) {
            choices.push(element.value.other);
        }
        return { choices };
    },
    ({ value }) => value.choices.length || value.other != null
);

export const ConnectedViewMultipleChoiceElement = connectReadElement(
    ViewMultipleChoiceOtherElement,
    element => ({
        choices: element.value.map(choice => element.trans.choices[choice]),
    }),
    ({ value }) => value.length
);

export class EditMultipleChoiceOtherElement extends Component {
    constructor(props) {
        super(props);

        this.handleSave = this.handleSave.bind(this);
        this.handleChoiceChange = this.handleChoiceChange.bind(this);
        this.handleOtherChange = this.handleOtherChange.bind(this);
        const choices = this.props.value.choices.reduce((choices, choice) => {
            choices[choice] = true;
            return choices;
        }, {});

        if (props.value.other) {
            choices[props.otherKey] = true;
        }

        this.state = { choices, other: props.value.other };
    }

    handleSave() {
        return this.props.onSave();
    }

    getValue() {
        const value = {
            choices: Object.keys(this.state.choices).filter(key => key != this.props.otherKey),
        };
        if (this.state.choices[this.props.otherKey]) {
            value.other = this.state.other;
        }
        return value;
    }

    handleChoiceChange(choice) {
        const choices = { ...this.state.choices };
        if (this.state.choices[choice]) {
            delete choices[choice];
        } else {
            choices[choice] = true;
        }

        this.setState({ choices }, () => {
            this.props.onChange(this.getValue(), true);
        });
    }

    handleOtherChange(event) {
        this.setState({ other: event.target.value }, () => {
            this.props.onChange(this.getValue(), false);
        });
    }

    render() {
        return (
            <div className="field field--checkable-set">
                <div className="field__children">
                    {Object.keys(this.props.choices).map(key => {
                        const isSelected = !!this.state.choices[key];
                        const label = this.props.choices[key];
                        const id = uniqueId('multiple-choice-other_');
                        return (
                            <div className="field field--checkable" key={key}>
                                <div className="field__input">
                                    <input
                                        id={id}
                                        type="checkbox"
                                        value={key}
                                        checked={!!isSelected}
                                        onChange={() => this.handleChoiceChange(key)}
                                    />
                                </div>
                                <label htmlFor={id} className="field__title">
                                    {label}
                                </label>
                            </div>
                        );
                    })}
                    {this.renderOther()}
                </div>
            </div>
        );
    }

    renderOther() {
        if (!this.props.hasOther) {
            return '';
        }
        const isSelected = this.isOtherSelected();
        const key = this.props.otherKey;
        const label =
            this.props.otherOption ||
            this.props.intl.formatMessage({ id: 'brief_choice_other_option' });
        const id = uniqueId('multiple-choice-other_');
        return (
            <div className="field field--checkable" key={key}>
                <div className="field__input">
                    <input
                        id={id}
                        type="checkbox"
                        value={key}
                        checked={!!isSelected}
                        onChange={() => this.handleChoiceChange(key)}
                    />
                </div>
                <label htmlFor={id} className="field__title">
                    {label}
                </label>
                {isSelected && (
                    <div className="field__children">
                        <div className="field">
                            <div className="field__input">
                                <input
                                    type="text"
                                    className="input-text input-width--max"
                                    defaultValue={this.props.value.other}
                                    placeholder={this.props.otherPlaceholder}
                                    onChange={this.handleOtherChange}
                                    onBlur={this.handleSave}
                                    autoFocus={true}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }

    isOtherSelected() {
        return this.state.choices[this.props.otherKey];
    }
}
EditMultipleChoiceOtherElement.propTypes = {
    intl: PropTypes.object.isRequired,
    value: PropTypes.shape({
        choices: PropTypes.array.isRequired,
        other: PropTypes.string,
    }).isRequired,
    choices: PropTypes.object.isRequired,
    onChange: PropTypes.func,
    onSave: PropTypes.func,
    hasOther: PropTypes.bool,
    otherKey: PropTypes.string,
    otherOption: PropTypes.string,
    otherPlaceholder: PropTypes.string,
};
EditMultipleChoiceOtherElement.defaultProps = {
    onChange: () => {},
    onSave: () => {},
    otherKey: '__other__',
    otherOption: '',
};

const EditMultipleChoiceOtherElementWithIntl = injectIntl(EditMultipleChoiceOtherElement);

export const ConnectedEditMultipleChoiceOtherElement = connectEditElementToBriefStore(
    EditMultipleChoiceOtherElementWithIntl,
    element => ({
        value: element.value,
        choices: element.trans.choices,
        otherOption: element.trans.otherOption,
        otherPlaceholder: element.trans.otherPlaceholder,
        hasOther: true,
    })
);

export const ConnectedEditMultipleChoiceElement = connectEditElementToBriefStore(
    EditMultipleChoiceOtherElementWithIntl,
    element => ({
        value: {
            choices: element.value,
            other: null,
        },
        choices: element.trans.choices,
        hasOther: false,
    }),
    value => value.choices
);



// WEBPACK FOOTER //
// ./src/web/js/contest/components/brief/multiple-choice-other-element.jsx